<template>
  <div>
    <PageHeader title="مدیریت بنر هدیه" :items="pageHeaderItems" />

    <Loader v-if="loading" />
    <div v-else class="card">
      <Section title="بنر هدیه">
        <form @submit.prevent="onSubmit" class="inner__style">
          <div class="d-flex flex-column flex-col gap-3">
            <b-row>
              <b-col>
                <ImageUploader
                  :img="model.largeImage"
                  :uploadLoading="uploadLargeImageLoading"
                  :secondTitle="`سایز 100 × 2800 `"
                  title="عکس بنر  ورژن دسکتاپ را انتخاب کنید"
                  @uploadImage="uploadLargeImage"
                  @deleteImage="model.largeImage = ''"
                />
              </b-col>
              <div class="mt-2">
                <BaseText v-model="model.largeImageText" title="متن جایگزین " placeholder="متن جایگزین " labelClass="labelClass" />
              </div>
            </b-row>

            <b-row>
              <b-col>
                <ImageUploader
                  :img="model.smallImage"
                  :uploadLoading="uploadSmallImageLoading"
                  title="عکس بنر  ورژن تبلت و موبایل را انتخاب کنید"
                  secondTitle="سایز 50 × ۱40۰"
                  @uploadImage="uploadSmallImage"
                  @deleteImage="model.smallImage = ''"
                />
              </b-col>
              <div class="mt-2">
                <BaseText v-model="model.smallImageText" title="متن جایگزین " placeholder="متن جایگزین " labelClass="labelClass" />
              </div>
            </b-row>
            <div class="card mt-2">
              <Section title="تنطیمات بنر">
                <div class="mb-2">
                  <BaseText v-model="model.link" title="لینک شود به" placeholder="لینک" labelClass="labelClass" />
                </div>
                <div class="d-flex align-items-center mt-5">
                  <Radio class="d-flex flex-row" :componentData="showTypes" :value="model.show" @input="model.show = $event" title="نمایش در سایت" />
                </div>
              </Section>
            </div>

            <div class="d-flex justify-content-end gap-2 mt-3">
              <b-button variant="secondary" @click="$router.go(-1)">انصراف</b-button>

              <Button text="ثبت" btnClass="upload-btn btn-border" type="submit" :loading="loading" @click="onSubmit" />
            </div>
          </div>
        </form>
      </Section>
    </div>

    <Toast title="با موفقیت ذخیره شد" submit :showToast="showToast" />
  </div>
</template>

<script>
import Button from '../../common/Button.vue'
import Loader from '../../widgets/loader.vue'
import fileMannager from '../../../services/file'
import Toast from '../../../components/common/Toast.vue'
import ImageUploader from '../../user/ImageUploader.vue'
import PageHeader from '../../layoutComponents/page-header.vue'
import BaseText from '../../common/form/formModules/BaseText.vue'
import skillUpBannerProvider from '../../../services/skillUp/banner'
import Section from '../../common/form/Section.vue'
import Radio from '../../common/form/formModules/Radio.vue'

export default {
  name: 'GiftBanner',
  components: { PageHeader, Loader, BaseText, Button, ImageUploader, Toast, Section, Radio },
  props: {
    update: {
      type: Boolean,
    },
  },
  data() {
    return {
      loading: false,
      showToast: false,
      uploadLargeImageLoading: false,
      uploadSmallImageLoading: false,
      pageHeaderItems: [
        { text: 'داشبورد', href: '/' },
        { text: 'تنظیمات', active: true },
      ],
      model: {
        id: undefined,
        link: undefined,
        style: undefined,
        order: undefined,
        title: undefined,
        largeImage: undefined,
        smallImage: undefined,
        firstColor: undefined,
        thirdColor: undefined,
        description: undefined,
        secondColor: undefined,
        largeImageText: undefined,
        smallImageText: undefined,
        show: false,
      },
      showTypes: [
        {
          value: 'روشن',
          key: true,
        },
        {
          value: 'خاموش',
          key: false,
        },
      ],
    }
  },
  async mounted() {
    await this.getBannerType(4)
  },
  methods: {
    async uploadLargeImage(e) {
      this.uploadLargeImageLoading = true
      const req = await fileMannager.addImage({
        base64image: e.dataUrl,
      })
      this.uploadLargeImageLoading = false
      this.model.largeImage = req.data.data.downloadUrl
    },
    async uploadSmallImage(e) {
      this.uploadSmallImageLoading = true
      const req = await fileMannager.addImage({
        base64image: e.dataUrl,
      })
      this.uploadSmallImageLoading = false
      this.model.smallImage = req.data.data.downloadUrl
    },

    async getBannerType(type) {
      try {
        const result = await skillUpBannerProvider.getBannerType(type)
        if (result.status === 200) this.model = result.data.data.output
      } catch (error) {
        return false
      }
    },
    async onSubmit() {
      this.showToast = false
      this.loading = true
      try {
        await skillUpBannerProvider.updateBanner(this.model)
        this.showToast = true
        this.loading = false
      } catch (error) {
        this.showToast = false
        this.loading = false
      }
    },
  },
}
</script>

<style lang="scss" scoped>
::v-deep .bv-no-focus-ring {
  display: flex;
  > div {
    margin-left: 20px;
  }
}

::v-deep .custom-control-input {
  margin-left: 5px;
}
::v-deep .labelClass {
  min-width: 100px !important;
}

.inner__style {
  background-color: white;
  padding: 23px;
}

.__color {
  width: 100%;
  border: 1px solid rgb(219, 214, 207);
  border-radius: 4px;
  height: 2.06875rem;
  display: flex;
  align-items: center;
  gap: 2;
}

.__input_color {
  width: inherit;
  background-color: unset;
  height: 2.06875rem;
  border: none;
  outline: none;
}

.upload-btn {
  margin-right: 10px !important;
  background: #556ee6 !important;
  border-radius: 4px !important;
  color: white !important;
  padding: 8px 28px !important;
  width: 119.1px;
}

.__text_area {
  width: 100%;
  border-color: #ced4da;
  border-radius: 4px;
  padding: 6px 10px;
}

.__text_area:focus-visible {
  outline: none;
}

.error-wrapper {
  text-align: center;
  * {
    color: #4a4a4a;
    font-style: normal;
    font-weight: normal;
  }

  .error-title {
    font-size: 16px;
    margin-bottom: 40px;
    line-height: 23px;
  }

  .error-text {
    font-size: 14px;
    line-height: 20px;
    margin: 25px 0;
  }
  button {
    font-size: 16px;
    line-height: 23px;
    background-color: transparent;
    outline: none;
    border: none;
  }
  .buttons {
    display: flex;
    align-items: center;
    justify-content: center;
  }
  .approveButton {
    padding: 6px 90px;
    color: white;
    background: #556ee6;
    border-radius: 4px;
  }
  .cancelButton {
    padding: 6px 90px;
    margin-left: 12px;
    color: white;
    background: #74788d;
    border-radius: 4px;
  }
}
::v-deep .__image {
  height: auto;
}
::v-deep .__image_box {
  padding: 0 50px;
}
</style>
